<template>
  <div>
    <app-cells><h2 class="title title--family">Invoice</h2></app-cells>
    <div class="hm-folio__content">
      <div class="hm-folio__top">
        <app-cells v-if="isHotelReception || isGeneralManager || isHotelReservations">
          <HMButton @click.native="onShowModalPayment"><span>Add Payment</span></HMButton>
          <HMButton @click.native="onShowModalService" background="linear-gradient(0deg, #FFCDB5 0%, #FBE0D2 100%)" color="#A4744A">
            <span>Add Service</span>
          </HMButton>
        </app-cells>
      </div>
      <template v-if="transactionItemsInvoice.length > 0">
        <HMFolioList key="fetchTransactionsInvoice" @postVoid="onVoidTransaction('fetchTransactionsInvoice')" :transactions="transactionItemsInvoice" />
      </template>
      <HMSlug v-else style="margin: 0 20px 20px;">
        <template #img><img alt="Services" src="@/assets/img/hm-services.png"/></template>
        <template #title>No services or payments yet</template>
        <template #text>All future services and charges will appear here once added.</template>
      </HMSlug>
    </div>
    <app-cells><h2 class="title title--family">Payment at the property</h2></app-cells>
    <div class="hm-folio__content">
      <template v-if="transactionItemsPayment.length > 0">
        <HMFolioList key="fetchTransactionsPayment" @postVoid="onVoidTransaction('fetchTransactionsPayment')" :transactions="transactionItemsPayment" />
      </template>
      <HMSlug v-else style="margin: 20px;">
        <template #img><img alt="Services" src="@/assets/img/hm-services.png"/></template>
        <template #title>No services or payments yet</template>
        <template #text>All future services and charges will appear here once added.</template>
      </HMSlug>
    </div>
    <modal
      :adaptive="true"
      :clickToClose="false"
      :height="'auto'"
      :reset="true"
      :scrollable="true"
      :width="400"
      name="payment-form"
    >
      <div class="popup-new">
        <button class="popup-new__close" type="button" @click="$modal.hide('payment-form')"></button>
        <div class="popup-new__title">Add Payment</div>
        <div class="popup-new__body">
          <form @submit.prevent="onCheckForm('paymentForm', 'onCreatePayment')">
            <app-form-field :marginBottom="20" class="family" label="Method" required>
              <app-cells :indent="false">
                <app-radio
                  v-for="item in method_options"
                  :key="item.code"
                  v-model="paymentForm.method"
                  :checked="paymentForm.method"
                  :value="item.code"
                  class="family"
                  name="method"
                >
                  <template #label>{{ item.name }}</template>
                </app-radio>
              </app-cells>
              <template #error>
                <div v-if="$v.paymentForm.method.$dirty && !$v.paymentForm.method.required">Required field</div>
              </template>
            </app-form-field>
            <app-form-field v-if="paymentForm?.method === 'cash'" :marginBottom="20" label="Currency" required class="family">
              <app-select
                v-model="paymentForm.currency"
                :options="currency_options"
                :clearable="false"
                :reduce="item => item.code"
                placeholder="Currency"
                class="family"
                :error="$v.paymentForm.currency.$error"
              />
              <template #error>
                <div v-if="$v.paymentForm.currency.$dirty && !$v.paymentForm.currency.required">Required field</div>
              </template>
            </app-form-field>
            <app-form-field :marginBottom="20" class="family" label="Amount" label-for="paymentAmount" required>
              <app-fin-number
                v-model="paymentForm.amount"
                id="paymentAmount"
                name="paymentAmount"
                placeholder="0"
                :error="$v.paymentForm.amount.$error"
              />
              <template #error>
                <div v-if="$v.paymentForm.amount.$dirty && !$v.paymentForm.amount.required">Required field</div>
              </template>
            </app-form-field>
            <app-form-field :marginBottom="20" class="family" label="Notes" label-for="paymentNotes">
              <app-textarea
                v-model="paymentForm.notes"
                id="paymentNotes"
                placeholder="Notes"
                class="family"
              />
            </app-form-field>
            <app-cells :indent="false" position="center">
              <HMButton :loading="isSubmittingPaymentForm"><span>Create</span></HMButton>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      :adaptive="true"
      :clickToClose="false"
      :height="'auto'"
      :reset="true"
      :scrollable="true"
      :width="400"
      name="service-form"
    >
      <div class="popup-new">
        <button class="popup-new__close" type="button" @click="$modal.hide('service-form')"></button>
        <div class="popup-new__title">Add Service</div>
        <div class="popup-new__body">
          <form @submit.prevent="onCheckForm('serviceForm', 'onCreateService')">
            <app-form-field :marginBottom="20" label="Category" class="family" required>
              <app-select
                v-model="serviceForm.transaction_category"
                :options="transaction_categories_options"
                :clearable="false"
                placeholder="Category"
                class="family"
                :error="$v.serviceForm.transaction_category.$error"
              />
              <template #error>
                <div v-if="$v.serviceForm.transaction_category.$dirty && !$v.serviceForm.transaction_category.required">Required field</div>
              </template>
            </app-form-field>
            <app-form-field :marginBottom="20" class="family" label="Amount" label-for="serviceAmount" required>
              <app-fin-number
                v-model="serviceForm.amount"
                id="serviceAmount"
                placeholder="0"
                :error="$v.serviceForm.amount.$error"
              />
              <template #error>
                <div v-if="$v.serviceForm.amount.$dirty && !$v.serviceForm.amount.required">Required field</div>
              </template>
            </app-form-field>
            <app-form-field :marginBottom="20" class="family" label="Notes" label-for="serviceNotes" :required="serviceForm?.transaction_category?.notes_required">
              <app-textarea
                v-model="serviceForm.notes"
                id="serviceNotes"
                placeholder="Notes"
                class="family"
                :error="$v.serviceForm.notes.$error"
              />
              <template #error>
                <div v-if="$v.serviceForm.notes.$dirty && !$v.serviceForm.notes.required">Required field</div>
              </template>
            </app-form-field>
            <app-cells :indent="false" position="center">
              <HMButton :loading="isSubmittingServiceForm"><span>Add</span></HMButton>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import HMSlug from '@/views/hotel-management/reservations/components/HMSlug.vue'
import HMButton from '@/views/hotel-management/reservations/components/HMButton.vue'
import HMFolioList from '@/views/hotel-management/reservations/components/HMFolioList.vue'
import {
  getHotelManagementTransactionCategories,
  getHotelManagementTransactions,
  postHotelManagementPaymentsCreateSingle,
  postHotelManagementTransactions
} from '@/http'
import { required, requiredIf } from 'vuelidate/lib/validators'

export default {
  name: 'HotelManagementReservationsInvoice',
  components: {HMFolioList, HMButton, HMSlug},
  data() {
    return {
      transactionItemsInvoice: [],
      transactionItemsPayment: [],
      paymentForm: {},
      serviceForm: {},
      transaction_categories_options: [],
      isSubmittingPaymentForm: false,
      isSubmittingServiceForm: false,
      currency_options: [
        {code: 'USD', name: 'US Dollars'},
        {code: 'TZS', name: 'Tanzanian Shillings'},
        {code: 'EUR', name: 'Euro'},
      ],
      method_options: [
        {code: 'cash', name: 'Cash'},
        {code: 'card', name: 'Credit Card'},
        {code: 'lipa', name: 'LIPA'},
      ],
    }
  },
  validations: {
    paymentForm: {
      method: {required},
      amount: {required},
      currency: {
        required: requiredIf(function() {
          return this.paymentForm?.method === 'cash'
        })
      },
    },
    serviceForm: {
      transaction_category: {required},
      amount: {required},
      notes: {
        required: requiredIf(function() {
          return this.serviceForm?.transaction_category?.notes_required
        })
      },
    }
  },
  computed: {
    isHotelReception() {
      return this.$store.state.userGroups.map(item => item.code).includes('hotel_reception')
    },
    isGeneralManager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    isHotelReservations() {
      return this.$store.state.userGroups.map(item => item.code).includes('hotel_reservations')
    },
  },
  created() {
    this.fetchTransactionsInvoice()
    this.fetchTransactionsPayment()
  },
  methods: {
    async fetchTransactionsInvoice() {
      const response = await getHotelManagementTransactions({invoice: true, reservation: this.$route.params.id})
      this.transactionItemsInvoice = response.data
    },
    async fetchTransactionsPayment() {
      const response = await getHotelManagementTransactions({invoice: false, reservation: this.$route.params.id})
      this.transactionItemsPayment = response.data
    },
    onCheckForm(form, action) {
      this.$v[form].$touch()
      if (this.$v[form].$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this[action]()
      }
    },
    onCreatePayment() {
      this.isSubmittingPaymentForm = true
      const data = {...this.paymentForm, reservation: Number(this.$route.params.id), invoice: true}
      if (this.paymentForm?.method !== 'cash') delete this.paymentForm.currency
      postHotelManagementPaymentsCreateSingle(data)
        .finally(() => {
          this.isSubmittingPaymentForm = false
        })
        .then(() => {
          this.fetchTransactionsInvoice()
          this.$modal.hide('payment-form')
        })
    },
    onCreateService() {
      this.isSubmittingServiceForm = true
      const data = {
        ...this.serviceForm,
        transaction_category: this.serviceForm.transaction_category.code,
        reservation: Number(this.$route.params.id),
        invoice: true
      }
      postHotelManagementTransactions(data)
        .finally(() => {
          this.isSubmittingServiceForm = false
        })
        .then(() => {
          this.fetchTransactionsInvoice()
          this.$modal.hide('service-form')
        })
    },
    onShowModalPayment() {
      this.paymentForm = {}
      this.$v.paymentForm.$reset()
      this.$modal.show('payment-form')
    },
    onShowModalService() {
      getHotelManagementTransactionCategories({debit: true})
        .then(response => {
          this.transaction_categories_options = response.data
          this.serviceForm = {}
          this.$v.serviceForm.$reset()
          this.$modal.show('service-form')
        })
    },
    onVoidTransaction(action) {
      this[action]()
    },
  }
}
</script>

<style scoped>
.hm-folio__content {
  border-radius: 16px;
  border: 1px solid #E9E9E9;
  background: #FFF;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.06);
}

.hm-folio__top {
  padding: 30px 20px 0 30px;
}
</style>
